"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var ScriptProvider_1 = __importDefault(require("../Common/ScriptProvider"));
var format_1 = require("../Common/utils/format");
var useTracking_1 = __importDefault(require("../Common/utils/useTracking"));
var ContactSupport_1 = __importDefault(require("./ContactSupport"));
var VerifyPaymentCardContext_1 = __importDefault(require("./VerifyPaymentCardContext"));
var VerifyPaymentCardStrings_1 = __importDefault(require("./VerifyPaymentCardStrings"));
var VerifyCardError = function (_a) {
    var defaultError = _a.defaultError, submitRes = _a.submitRes;
    var _b = React.useContext(VerifyPaymentCardContext_1["default"]), consumer = _b.consumer, orderCart = _b.orderCart;
    var trackContactSupport = useTracking_1["default"]().trackContactSupport;
    var getErrorMessage = function (res) {
        var sameCardErrorMessage = 'Please verify your identity with a different payment card';
        var bffErrorMessage = (res &&
            res.error &&
            res.error.graphQLErrors &&
            res.error.graphQLErrors.length &&
            res.error.graphQLErrors[0] &&
            res.error.graphQLErrors[0].message) ||
            defaultError;
        if (bffErrorMessage.trim() === sameCardErrorMessage) {
            return VerifyPaymentCardStrings_1["default"].verifyWithADifferentCard();
        }
        return defaultError;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(design_language_1.Text, { display: design_language_1.Text.DisplayModes.Inline, styles: design_language_1.Text.Styles.SectionSubtext }, getErrorMessage(submitRes)),
        consumer && orderCart && (React.createElement(ScriptProvider_1["default"]
        // tslint:disable-next-line:max-line-length
        , { 
            // tslint:disable-next-line:max-line-length
            source: "https://d.la2-c1-ph2.salesforceliveagent.com/content/g/js/29.0/deployment.js", sourceId: "saleforce-live-agent" },
            React.createElement(ContactSupport_1["default"], { consumerEmail: consumer.email, consumerId: consumer.id, consumerName: consumer.firstName, consumerPhoneNumber: consumer.phoneNumber, orderCartId: orderCart.id, orderTotal: format_1.formatCurrency(orderCart.total || 0, {
                    includeUnits: true
                }), trackContactSupport: trackContactSupport })))));
};
exports["default"] = VerifyCardError;
